import { Routes } from '@angular/router';

import { AuthGuard } from '@lib/auth';
import { memberProfileResolver } from '@dp/core/resolvers/member-profile.resolver';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/access/access-guest/access-guest.component').then(c => c.AccessGuestComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/login/login.component').then(c => c.LoginComponent),
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    loadComponent: () => import('./pages/access/access-authorized/access-authorized.component').then(c => c.AccessAuthorizedComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'medical-documents/:helsiPatientId',
      },
      {
        path: 'medical-documents/:helsiPatientId',
        loadComponent: () => import('./pages/medical-data/medical-data.component').then(c => c.MedicalDataComponent),
        resolve: {
          memberProfile: memberProfileResolver,
        },
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
